<div class="modal-header">
  <h3 class="modal-title">Sourcing Default By Parent ME</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise = !minimise"></i>
    <i class="fa fa-times" (click)="modalClose()"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="main-hdr-bg">
    <b>Key:</b>
    <span class="key-badge">PARENT ME NAME</span>
  </div>

  @if (entities?.length > 0 && entities.length < 10) {
<div class="entitie-holder">
    @for (entity of entities; track $index; let i = $index) {
<div class="btn-group entity-chip-group"
        >
      <button type="button" class="btn btn-xs btn-default entity-chip">
        {{ entity.data?.PARENT_ME_NAME || entity.PARENT_ME_NAME }}
      </button>
      <button type="button"
              class="btn btn-xs btn-danger entity-remove"
              (click)="removeEntity(i)"
              aria-label="Remove entity">
        <span class="fa fa-times"></span>
      </button>
    </div>
}
  </div>
}

  @if (entities?.length >= 10) {
<div class="entitie-holder entity-count">
    <label>
      Selected Entities Count:
      <span class="badge badge-pill badge-info">{{ entities.length }}</span>
    </label>
  </div>
}

  @if (!entities?.length) {
<div class="no-entities">
    No entities selected.
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saveClicked || !entities?.length" (click)="saveData()">
    @if (saveClicked) {
<i class="fa fa-spinner fa-pulse"></i>
}
    Save
  </button>
  <button class="cancel-button" type="button" (click)="modalClose()">Cancel</button>
</div>
